/* eslint-disable import/prefer-default-export */
export const ERROR_EMAIL_IN_USE = /The email address has already been taken/;